import { FC, ReactNode } from 'react'
import { Card } from '@instabox/consumer-web-ui'

import styles from './faqSearchResults.module.scss'

interface FAQSearchResultProps {
  children?: ReactNode | undefined
}

export const FAQSearchResults: FC<FAQSearchResultProps> = ({ children }) => {
  return (
    <Card>
      <ul>{children}</ul>
    </Card>
  )
}

export const FAQSearchResult: FC<FAQSearchResultProps> = ({ children }) => {
  return <li className={styles.item}>{children}</li>
}
